import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

export default function WhatsAppFab({ phone = "5491166861309" }) {
  return (
    <motion.a
      data-testid={HOME.whatsappFab}
      href={`https://wa.me/${phone}?text=${encodeURIComponent("¡Hola LUVA!")}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8, duration: 0.4 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.94 }}
      aria-label="Contactar por WhatsApp"
      title="WhatsApp +54 9 11 6686-1309"
      className="fixed bottom-6 right-5 z-40 text-white flex items-center justify-center shadow-2xl"
      style={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: "#25D366" }}
    >
      <svg viewBox="0 0 24 24" className="w-9 h-9" fill="currentColor" aria-hidden>
        <path d="M19.05 4.91A10.024 10.024 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.78 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.02zM12.04 20.13h-.01a8.22 8.22 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.21 8.21 0 0 1-1.26-4.36c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.41a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.21-8.24 8.21zm4.52-6.16c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.42l-.48-.01a.92.92 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.43 1.03 2.6.12.17 1.78 2.72 4.31 3.82.6.26 1.07.41 1.44.53.61.19 1.16.17 1.6.1.49-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.14-1.18-.06-.1-.22-.16-.47-.28z"/>
      </svg>
    </motion.a>
  );
}
